import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

//remove all importants from this file once the flush issue has been resolved.

export const DialogStyles: StyleRule = ({ theme }) => {
    return {
        overflow: 'hidden',
        maxWidth: '100vw !important',
        maxHeight: '100vh !important',
        width: '100vw',
        height: '100vh',
        borderTopLeftRadius: '0 !important',
        borderTopRightRadius: '0 !important',
        borderBottomLeftRadius: '0 !important',
        borderBottomRightRadius: '0 !important',
        '& > div': {
            padding: pxToRem(14),
        },
        [theme.screen.laptop]: {
            maxWidth: '90vw !important',
            maxHeight: '90vh !important',
            width: pxToRem(1000),
            height: '90vh',
            borderTopLeftRadius: '8px !important',
            borderTopRightRadius: '8px !important',
            borderBottomLeftRadius: '8px !important',
            borderBottomRightRadius: '8px !important',
            '& > div': {
                padding: pxToRem(32),
            },
        },
        '& h2': {
            height: 'auto',
        },
    };
};
